var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('action')}`,"expanded":""},on:{"input":_vm.onSelect}},[_c('option',{key:"Create",attrs:{"value":"create"}},[_vm._v(" "+_vm._s(_vm.$tc('create'))+" ")]),_c('option',{key:"Update",attrs:{"value":"update"}},[_vm._v(" "+_vm._s(_vm.$tc('update'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }